<template>
  <div class="page_container myFooter_wrap">
    <div class="myFooter_content">
      <div class="myleft">
        <div class="logo">
          <img @click="goIndex('/')"
            src="https://download.hecoos.com/enlightv/2025-17/9afd9fdb8b5717b4b118b43b3c449e13.png" alt="" srcset="" />
        </div>
        <div class="brand">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
              letter-spacing: 3px;
            ">
            品牌
          </p>
          <a href="https://www.enlightv.com">EnlightV澜景科技</a>
          <a href="https://www.hirender.com">Hirender</a>
          <a href="https://www.mhat.cn/sy">澜帽子</a>
          <a href="https://www.lanerp.com/index/enlightv.html">澜精灵ERP</a>
        </div>

         <div class="brand">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
              letter-spacing: 3px;
            ">
            解决方案
          </p>
          <router-link to="/projection">投影映射</router-link>
          <router-link to="/lightingDesign">灯光</router-link>
          <router-link to="/virtualProduction">虚拟制作xR/VP</router-link>
          <router-link to="/renderInteraction">实时渲染与交互</router-link>

        </div>

         <div class="brand">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
              letter-spacing: 3px;
            ">
            产品
          </p>
           <router-link to="/studio">Studio</router-link>
          <router-link to="/hecoosLighting">Lighting</router-link>
          <router-link to="/mediaServer">Server</router-link>
          <router-link to="/projectorbit">其他产品</router-link>
        </div>
        <div class="myFooter_call">
          <p style="
              font-size: 18px;
              color: #2a82e4;
              margin-bottom: 16px;
              font-weight: 700;
              letter-spacing: 3px;
            ">
            联系我们
          </p>
          <span>咨询热线</span>
          <span>400-600-1196（7x24小时）</span>
          <span>公司直机</span>
          <span>010-53608556（工作日 9:00-18:00 ）</span>
        </div>
      </div>
      <div class="myright">
        <div class="login" @click="goIndex('/login')">登录</div>
        <div class="register" @click="goIndex('/register')">注册</div>
        <div class="icon">
          <div class="icon_item" @mouseover="show = true" @mouseout="show = false">
            <img src="https://download.hecoos.com/enlightv/2025-17/d464b98e84ae0305ebd71d9f2994f968.png" alt=""
              srcset="" />
            <div class="img_QR" v-show="show">
              <img src="https://download.hecoos.com/enlightv/2025-20/3d6cafecb14f319c641d6e306b56d488.png" alt="">
            </div>
          </div>
          <div @click="jumpToO('https://www.zhihu.com/org/hecoosquan-an-she-ji')">
            <img src="https://download.hecoos.com/enlightv/2025-17/8bba227d4c074a01585b4ecfcf979177.png" alt=""
              srcset="" />
          </div>
          <div @click="jumpToO('https://space.bilibili.com/500474865?from=search&seid=12579826703428817436')">
            <img style="width: 65%; height: 65%;"
              src="https://download.hecoos.com/enlightv/2025-17/9c744bdebcae1c98b950ecedcc1d2248.png" alt=""
              srcset="" />
          </div>
        </div>
      </div>
    </div>
    <div class="tail">
      <div style="
          color: rgba(255, 255, 255, 0.64);
          font-family: '等线 light';
          font-weight: 550;
        ">
        京ICP备16030301号-3
      </div>
      <div class="rig">
        <div @click="jumpTo('/privacyPolicy')" style="font-family: '等线 light'; font-weight: 550;cursor: pointer; ">隐私政策
        </div>
         <div style="margin-left: 60px;">
            <router-link to="/llm-info">AI索引</router-link>
        </div>
        <div style=" margin-left: 60px;font-family: '等线 light';font-weight: 550; cursor: pointer;" @click="jumpTo('/serviceAgreement')">服务协议</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    goIndex(url) {
      if (url === '/login') {
        if (localStorage.getItem("token")) {
          Message.error('您已登录，无需重复登录。')
          setTimeout(() => {
            this.$router.push("/personalCenter");
          }, 1000);
          return
        }
      }
      this.$router.push(url);
    },
    jumpTo(url) {
      this.$router.push(url);
    },
    jumpToO(url) {
      window.open(url)
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";

.page_container {
  background-color: #121416;
  padding: 120px 120px 10px 120px;
  // font-family: PingFangSC-Semibold;
  font-family: "思源黑体Medium" !important;
}
</style>
